import React from 'react';

export default ({ children }) => (
  <h1>{children}</h1>
);
